<div
  *ngIf="type === 'incentives'"
  class="header"
  [ngStyle]="{'background-color': '#ED1C24'}"
><div>Incentives</div></div>
<div
  *ngIf="type === 'mcc'"
  class="header"
  [ngStyle]="{'background-color': '#2D3393'}"
><div>MCC</div></div>
<div
  *ngIf="type === 'time'"
  class="header"
  [ngStyle]="{'background-color': '#8F499C'}"
><div>Time<span>(hrs per week)</span></div></div>
<div
  *ngIf="type === 'tposm'"
  class="header"
  [ngStyle]="{'background-color': '#006F45'}"
>TPOSM</div>
<div class="feedback"><div>{{ feedback }}</div></div>
